// import { RootStore } from 'mobx-stores/root-store'
import { TriggerSearchFunc, StatisticsTableBase } from 'mobx-stores/utils'
import { StatisticsStores } from 'models/statistics'

export class StatisticsTableStore extends StatisticsTableBase {
  private rootStore: any
  public storeSelected: number | StatisticsStores = StatisticsStores.ALLSTORES

  constructor(rootStore: any) {
    super(rootStore)
    this.rootStore = rootStore
  }

  //ACTIONS — selection only; callers run triggerSearch to avoid duplicate table fetches on mount.
  public setStoreSelected = (storeId): void => {
    this.storeSelected = storeId
  }

  // METHODS
  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    let storeStatistics = null
    try {
      if (this.storeSelected === StatisticsStores.ALLSTORES) {
        storeStatistics = await this.rootStore.generalStore.api.statisticsApi.getAllStoreStatistics(
          this.storeFilter,
          { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
        )
      } else {
        storeStatistics = await this.rootStore.generalStore.api.statisticsApi.getStoreStatistics(
          this.storeSelected,
          this.productFilter,
          { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
        )
      }
    } catch {
      storeStatistics = null
    }
    this.handleSearchResult(storeStatistics)
  }

}
